<template>
  <div>
  <div v-if="passenger && passenger.state_movil !== 'on-your-own'">
    <h3 class="title">ABORDAR PASAJERO</h3>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12" id="user-info">
          <div class="name text-center mt-5 mb-3">{{ passenger.name }}</div>
          <div class="address text-center">
            <img class="mr-2 mb-3 mt-2" src="/static/img/svg-icons/location-pin.svg"/>
            {{ passenger.address }}
          </div>
          <div class="hour text-center">
            <img class="mr-2 mb-3 mt-2" src="/static/img/svg-icons/time.svg"/>
            {{ passenger.hour }}
          </div>
          <div class="hour text-center" v-if="passengersShowPhone">
            <div class="w-50 m-auto">
              <img class="mr-2 mb-3 mt-2" src="/static/img/svg-icons/phone-outline-icon.svg"/>
              {{ passenger.phone }}
            </div>
            <div class="w-50 m-auto">
              <a class="btn-call" :href="'tel:' + passenger.phone">Llamar</a>
            </div>
          </div>
        </div>
        <div class="col-sm-12" id="chronometer">
          <div class="time text-center">{{ chronometerDisplayTime }}</div>
          <button
            class="d-block m-auto button-app-big"
            style="background: #04c70f"
            type="button"
            @click="startChronometer()"
            v-if="!chronometerIsRuning">
            Iniciar espera pasajero
          </button>
          <button
            class="d-block m-auto button-app-big"
            style="background: #C70006"
            type="button"
            @click="stopChronometer()"
            v-if="chronometerIsRuning">
            Terminar espera pasajero
          </button>
        </div>
      </div>
    </div>
  </div>

  <div v-if="passenger && passenger.state_movil === 'on-your-own'">
    <table width="100%" border="0" align="center" cellpadding="2" cellspacing="2">
      <tbody>
        <tr>
          <td class="background-app" colspan="7" width="100%" align="center" style="padding:15px 0">
            <br/>
            <span style="font-size: 20px; color: #FFF; font-weight:600">DETALLE DE SERVICIO</span>
          </td>
        </tr>
        <tr>
          <td align="center" bgcolor="#CCCCCC" style="padding:30px 0">
            <span style="text-align:center; font-size:30px; color:#009;"><strong>{{ passenger.name }}</strong></span>
          </td>
        </tr>
        <tr>
          <td height="100" align="center" bgcolor="#E74C3C" valign="middle" style="vertical-align: middle; margin: 10px 0;">
            <span style="text-align: center; font-size: 22px; color: #FFF">El pasajero a notificado que se irá por su cuenta (PSC)</span>
          </td>
        </tr>
      </tbody>
    </table>
    <table width="100%" align="center" style="margin-top: 20px">
      <tbody>
        <tr>
          <td align="center">
            <input type="button" style="border:none; text-align:center; border-radius:20px; height: 60px" value="Volver" @click="goBack()"/>
          </td>
        </tr>
      </tbody>
    </table>
  </div>



  <div class="modal" :class="lightboxClass" id="light" style="box-shadow: rgb(26,36,52) 0px 5px 15px 10px; opacity: 0;">
    <table width="100%" border="0">
      <tbody>
        <tr>
          <td height="20px"> </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <a @click="setState('no-position', id_pay)">
              <img src="/static/img/iconos-estado/NP.png" width="25%"/>
            </a>
          </td>
        </tr>
        <tr>
          <td style="text-align: center;">
            <span class="color-text-app" style="font-size: 20px;"><strong>NO DA POSICIÓN</strong></span>
          </td>
        </tr>
        <tr>
          <td height="50px"> </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <a @click="setState('on-route', id_pay)">
              <img src="/static/img/iconos-estado/OK.png" width="25%"/>
            </a>
          </td>
        </tr>
        <tr>
          <td style="text-align: center;">
            <span class="color-text-app" style="font-size: 20px;"><strong>EN CAMINO</strong></span>
          </td>
        </tr>
        <tr>
          <td height="50px"> </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <a @click="setState('on-your-own', id_pay)">
              <img src="/static/img/iconos-estado/PSC.png" width="25%"/>
            </a>
          </td>
        </tr>
        <tr>
          <td style="text-align: center;">
            <span class="color-text-app" style="font-size: 20px;"><strong>POR SU CUENTA</strong></span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</template>

<script>
import http from '../http.js'

export default {
  name: 'RecoPassenger',
  data() {
    return {
      id_pay: this.$route.params.id_pay,
      passenger_ID: this.$route.params.passenger_ID,
      lightboxClass: 'hide',
      chronometerDisplayTime: '00:00',
      chronometerIsRuning: false,
      passenger: {
        name: '',
        address: '',
        hour: '',
        phone: '',
        state_movil: ''
      },
      position: {
        lat: undefined,
        lng: undefined
      },
      passengersShowPhone: null,
      chronometerInterval: undefined
    }
  },
  mounted() {
    this.$root.loading = true
    this.id_pay = this.$route.params.id_pay
    this.passenger_ID = this.$route.params.passenger_ID

    this.lightboxClass = 'hide'
    this.chronometerDisplayTime = '00:00'
    this.chronometerIsRuning = false
    this.passenger = {
      name: '',
      address: '',
      hour: '',
      phone: '',
      state_movil: ''
    }
    this.position = {
      lat: undefined,
      lng: undefined
    }

    // Llamar fetchAppPassengersShowPhone primero
    this.fetchAppPassengersShowPhone()

    // Obtener posición actual
    this.getCurrentPosition()

    // Cargar el pasajero
    this.loadPassenger()
  },
  methods: {
    fetchAppPassengersShowPhone() {
      if (this.passengersShowPhone === null) {
        http.get('app/settings/app_passengers_show_phone').then(response => {
          const data = response.data
          this.passengersShowPhone = data.value === "1"
        }).catch(error => {
          this.$root.catchErrorApi(error)
        })
      }
    },

    getCurrentPosition() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          this.position = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
        }, error => {
          console.error('Error getting position:', error)
        }, {
          timeout: 10000,
          enableHighAccuracy: false
        })
      }
    },

    loadPassenger() {

      http.get(`app/passenger/${this.passenger_ID}`).then(response => {
        this.$root.loading = false
        this.passenger = response.data.passenger

        if (response.data.passenger.chronometer_timer) {
          this.lightboxClass = 'show'
        }
      }).catch(error => {
        this.$root.catchErrorApi(error)
      })
    },

    startChronometer() {
      this.chronometerIsRuning = true
      let seconds = 0

      this.chronometerInterval = setInterval(() => {
        seconds++
        const minutes = Math.floor(seconds / 60)
        const remainingSeconds = seconds % 60
        this.chronometerDisplayTime = `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`
      }, 1000)
    },

    stopChronometer() {
      this.$root.loading = true

      if (this.chronometerInterval) {
        clearInterval(this.chronometerInterval)
        this.chronometerInterval = undefined
        this.lightboxClass = 'show'

        http.put(`app/passenger/${this.passenger_ID}/time/${this.chronometerDisplayTime}`).then(response => {
          this.$root.loading = false
          this.passenger = response.data.passenger
        }).catch(error => {
          this.$root.catchErrorApi(error)
        })
      }
    },

    setState(state, id_pay) {
      let positionInterval

      http.put(`app/passenger/${this.passenger_ID}/state-movil/${state}`).then(() => {
        this.lightboxClass = 'hide'
        this.$router.push(`/reco/${id_pay}`)

        // Enviar localización si está disponible
        if (this.isPositionCapture()) {
          http.put(`app/passenger/${this.passenger_ID}/localization-movil/${this.position.lat}/${this.position.lng}`).catch(error => {
            this.$root.catchErrorApi(error)
          })
        } else {
          // Intentar obtener posición cada 3 segundos como en el Angular original
          positionInterval = setInterval(() => {
            navigator.geolocation.getCurrentPosition(position => {
              this.position = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              }

              if (this.isPositionCapture()) {
                http.put(`app/passenger/${this.passenger_ID}/localization-movil/${this.position.lat}/${this.position.lng}`).then(() => {
                  clearInterval(positionInterval)
                }).catch(error => {
                  this.$root.catchErrorApi(error)
                })
              }
            }, error => {
              console.error('Error getting position:', error)
            }, {
              timeout: 10000,
              enableHighAccuracy: false
            })
          }, 3000)
        }
      }).catch(error => {
        this.$root.catchErrorApi(error)
      })
    },

    isPositionCapture() {
      return !(this.position.lat === undefined || this.position.lat === 0 ||
               this.position.lng === undefined || this.position.lng === 0)
    },

    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="css">
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  z-index: 1001;
  opacity: .75;
}
.modal {
  position: absolute;
  border: #1a2434 5px solid;
  border-radius: 5px;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: 95%;
  height: 95%;
  padding: 16px;
  background: #fff;
  color: #333;
  z-index: 1002;
  overflow: auto;
  min-height: 0;
}
.hide, .show {
  transition: all .4s ease;
}
.hide {
  opacity: 0 !important;
  height: 0px;
  overflow: hidden;
}
.show {
  opacity: 1 !important;
  height: 95%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/RecoPassenger.vue